import script from "./auth.vue?vue&type=script&lang=ts&setup=true"
export * from "./auth.vue?vue&type=script&lang=ts&setup=true"

import "./auth.vue?vue&type=style&index=0&id=f3ebfc0a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3ebfc0a"]])

export default __exports__